import { render, staticRenderFns } from "./AudioPlayerIcon.vue?vue&type=template&id=415b18cf&scoped=true"
import script from "./AudioPlayerIcon.vue?vue&type=script&lang=js"
export * from "./AudioPlayerIcon.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerIcon.vue?vue&type=style&index=0&id=415b18cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415b18cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415b18cf')) {
      api.createRecord('415b18cf', component.options)
    } else {
      api.reload('415b18cf', component.options)
    }
    module.hot.accept("./AudioPlayerIcon.vue?vue&type=template&id=415b18cf&scoped=true", function () {
      api.rerender('415b18cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/AudioPlayerIcon.vue"
export default component.exports